export const routes = {
  dashboard: '/phase1',
  map: '/phase1/map',
  report: '/phase1/report',
  vehicleList: '/phase1/vehicle-list',
}
